export const additionalFilterDefaultOptions = [
  { value: 'header_req', label: 'Header de requisição' },
  { value: 'body_req', label: 'Body de requisição' },
  { value: 'header_res', label: 'Header de resposta' },
  { value: 'body_res', label: 'Body de resposta' },
  { value: 'code_res', label: 'Código de resposta' },
]
